// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__eNG_N","notes":"Notes_notes__1-j43","note":"Notes_note__xwnk7","markdown":"Notes_markdown__5oc-2"};